import { deepmerge } from "@mui/utils";
import { cxnTheme } from "@chemaxon/design-system/theme";
import { Content } from "@chemaxon/design-system/color";
import { body3Strong } from "@chemaxon/design-system/typography/jscss";

import { MuiFormElementOverrides } from "@chemaxon/terminus-client/ui/utils/MuiFormElementOverrides";
import linkOverrides from "@chemaxon/terminus-client/ui/theme/LinkOverrides";

const synergyTheme = deepmerge(cxnTheme, {
  components: {
    MUIDataTableHeadCell: {
      styleOverrides: {
        fixedHeader: {
          zIndex: 0,
          borderColor: "black",
        },
        sortAction: ({ theme }) => ({
          "& svg": {
            marginTop: theme.spacing(0),
            width: 20,
          },
        }),
      },
    },
    MUIDataTableToolbar: {
      styleOverrides: {
        left: () => ({
          "& input": {
            fontSize: "16px",
          },
        }),
        actions: {
          "& button[data-testid=Search-iconButton]": {
            display: "none",
          },
        },
        root: {
          paddingLeft: 16,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        footer: {
          borderBottom: "none",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          ...body3Strong,
          color: Content.main,
          paddingTop: 11,
          paddingBottom: 5,
        },
      },
    },
    ...MuiFormElementOverrides,
    ...linkOverrides,
  },
});

export default synergyTheme;
